import axios from "axios";

const state = () => ({
  providers: [],
  providerObject: "",
});

const mutations = {
  SET_PROVIDERS(state, provider) {
    state.providers = provider;
  },
  SET_PROVIDER_OBJECT(state, providerObject) {
    state.providerObject = providerObject;
  },
  SET_COURSE_INTEGRATION(state, integration) {
    state.courseIntegration = integration;
  },
};

const getters = {
  getProviders: (state) => {
    return state.providers;
  },
  getProviderObject: (state) => {
    return state.providerObject;
  },
  getCourseIntegration: (state) => {
    return state.courseIntegration;
  },
};

const actions = {
  async fetchProviders({ commit }) {
    const url = `${process.env.VUE_APP_API_URL}/utilities/integration-providers`;
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.get(url, config);
      commit("SET_PROVIDERS", response.data);
    } catch (error) {
      console.log("Error fetching providers:", error);
    }
  },

  async fetchProviderObject({ commit }, id) {
    const url = `${process.env.VUE_APP_API_URL}/utilities/providers-object/${id}`;
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.get(url, config);
      commit("SET_PROVIDER_OBJECT", response.data);
    } catch (error) {
      console.log("Error fetching providers:", error);
    }
  },

  async updateProviderObject(_, payload) {
    const url = `${process.env.VUE_APP_API_URL}/utilities/integrate-course/${payload.id}`;

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
        "Content-Type": "application/json",
      },
    };

    const data = JSON.parse(payload.data);

    try {
      const response = await axios.post(url, data, config);

      return response;
    } catch (error) {
      console.log("Error updating provider object:", error);
      throw error;
    }
  },

  async fetchCourseIntegration({ commit }, courseId) {
    if (!courseId) {
      commit("SET_COURSE_INTEGRATION", null);
      return null;
    }
    const url = `${process.env.VUE_APP_API_URL}/utilities/current-integration/${courseId}`;
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_COURSE_INTEGRATION", response.data);
      return response.data;
    } catch (error) {
      console.log("Error fetching course integration:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
